import * as _ from 'lodash-es';

/**
 * To increase the diversity of faces in group cards, we want a random but stable sorting.
 * The faces in group cards is more aesthetic than informational so we can
 * sort in a less obvious way.
 * @param users
 * @param id
 */
function sortAndRotateById<T extends { id: string }>(users: T[], id: string) {
  const sortedUsers = _.sortBy(users, (user) => user.id);

  const index = _.sortedIndex(
    sortedUsers.map((user) => user.id),
    id,
  );

  return [...sortedUsers.slice(index), ...sortedUsers.slice(0, index)];
}

export default sortAndRotateById;
